<!-- src/app/admin/views/company/coordinator-view/coordinator-view.component.html -->

<div class="bannerback">
    <app-nav></app-nav>
</div>
<div class="container-fluid v4-bg-img">
    <div class="container p-0">
        <div class="d-flex justify-content-between pt-5">
            <div class="d-flex">
                <img class="img-icon" src="../../../../../assets/v-4-icone/laptop.png" alt="loading">
                <h2 class="font-600 p-0">{{"External Coordinator"| translator}}</h2>
            </div>
            <!-- <a [routerLink]="'/training/request'" class="create-training-btn mx-2 align-items-center d-flex">{{"Create a request"| translator}}<i
                class="pi pi-plus-circle mx-2"></i></a> -->
        </div>
        <div class="d-flex flex-row align-items-center flex-wrap my-3 mx-3">
            <span class="d-flex align-items-center">
                <span class="custom-bredcrum-btn d-flex align-items-center">
                    {{"Homepage"| translator}}
                </span>
                <span class=""><i class="pi pi-fw pi-angle-left"></i></span>
            </span>
            <span class="d-flex align-items-center">
                <span class="custom-bredcrum-btn font-600 d-flex align-items-center">
                    {{"External Coordinator"| translator}}
                </span>
            </span>

        </div>
    </div>


    <div [hidden]="skelition" class="container my-5">
        <div class="custom-bg">
            <div class="d-flex">
                <i class="pi pi-building icon-ui"></i>
                <h4 class="titels bottom-lineee">{{'Company Details' | translator}}</h4>
            </div>
            <div class="d-flex">
                <i class="pi pi-pencil icon-ui"></i>
                <h6 class="titels">{{companyData?.name}}</h6>
            </div>
            <div class="d-flex">
                <i class="pi pi-link icon-ui"></i>
                <a class="titels" [href]="companyData?.website">{{companyData?.website}}</a>
            </div>
            <div class="d-flex">
                <i class="fa fa-location icon-ui"></i>
                <h6 class="titels">{{companyData?.location}}</h6>
            </div>
        </div>

        <div class="d-flex justify-content-between my-3 align-items-center">

            <!-- Coordinators -->
            <h5 class="bold-600">{{'External Coordinator' | translator}}</h5>
            <div>
                <button class="py-2 v4-btn-every" *ngIf="!trainerView" (click)="addCoordinatorModal = true"><i
                        class="pi pi-plus v4-ml-2"></i>{{'Register External Coordinator' | translator}}</button>
                <!-- <p-button class="mx-1" label="{{'Add trainer' | translator}}" (onClick)="addTrainnerModal = true" icon="pi pi-plus"></p-button> -->
                <!-- <p-button class="mx-1" label="{{'Skill Training' | translator}}" (onClick)="redirectToSkill('655b25b65316702b1f3295c1')" icon="pi pi-plus-circle"></p-button> -->
                <!-- *ngIf="this.permissionService.hasPermission('SKILL_TRAINING', 'r')" -->
                <ng-container *ngFor="let item of dynamicTrainingItems">
                    <button class="mx-1 v4-btn-every py-2" (click)="redirectToSkill(item._id)">
                        <i class="pi pi-plus-circle v4-ml-2"></i>{{item.arabic | translator}}</button>
                </ng-container>

            </div>
        </div>


        <app-no-data [hidden]="coordinatorsData?.length > 0"></app-no-data>

        <p-table [hidden]="coordinatorsData.length <= 0 " styleClass="custom-table" [value]="coordinatorsData"
            dataKey="code" [paginator]="true" [scrollable]="true" [rows]="10" [selectionPageOnly]="true"
            [tableStyle]="{'min-width': '40rem'}">
            <ng-template pTemplate="header">
                <tr>
                    <th>{{"the name"| translator}} </th>
                    <th>{{"Email"| translator}}</th>
                    <th>{{"Gender"| translator}}</th>
                    <th>{{"National ID"| translator}}</th>
                    <th>{{"Phone Number"| translator}}</th>
                    <th *ngIf="!trainerView">{{"Action"| translator}}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-trainer>
                <tr>
                    <td>{{trainer.name.first}} {{trainer.name.middle}} {{trainer.name.last}}</td>
                    <td>{{trainer.email}}</td>
                    <td>{{trainer?.gender}}</td>
                    <td>{{trainer?.national_id}}</td>
                    <td>{{trainer?.phone}}</td>

                    <td *ngIf="!trainerView">
                        <span class="d-flex align-items-center">
                            <span class="tabel-circle-btn">
                                <i pTooltip='{{"Edit Trainer Details"| translator}}' tooltipPosition="top"
                                    (click)="trainerDataHolder = trainer ; updateTrainer = true; "
                                    class="pi pi-file-edit"></i>
                            </span>
                            <span class="tabel-circle-btn">
                                <i pTooltip='{{"Remove trainer"| translator}}' tooltipPosition="top"
                                    (click)="confirmDeleteTrainer(trainer?._id)" class="pi pi-times"></i>
                            </span>
                            <span class="tabel-circle-btn">
                                <i *ngIf="trainer.active.status" pTooltip='{{"Block Coordinator"| translator}}'
                                    tooltipPosition="top" (click)="deactivateInit(trainer?._id)"
                                    class="pi pi-minus-circle"></i>
                            </span>
                            <span *ngIf="!trainer.active.status" class="tabel-circle-btn">
                                <i pTooltip='{{"UnBlock Coordinator"| translator}}' tooltipPosition="top"
                                    (click)="UndoDeactivateUser(trainer?._id)" class="pi pi-check"></i>
                            </span>

                        </span>
                    </td>

                </tr>
            </ng-template>
        </p-table>




        <div class="d-flex justify-content-between my-3 align-items-center">
            <h5 class="bold-600">{{'Trainers' | translator}}</h5>
            <div *ngIf="!trainerView">
                <!-- <p-button label="{{'Add External Coordinator' | translator}}" (onClick)="addCoordinatorModal = true" icon="pi pi-plus"></p-button> -->
                <button class="mx-1 v4-btn-every py-2" (click)="addTrainnerModal = true"><i
                        class="pi pi-plus v4-ml-2"></i>{{'Add trainer' | translator}}</button>
                <!-- <p-button class="mx-1" label="{{'Skill Training' | translator}}" (onClick)="redirectToSkill()" icon="pi pi-plus-circle"></p-button> -->
                <!-- *ngIf="this.permissionService.hasPermission('SKILL_TRAINING', 'r')" -->
            </div>
        </div>


        <app-no-data [hidden]="companyData?.trainers?.length > 0"></app-no-data>

        <p-table [hidden]="companyData?.trainers?.length <= 0 " styleClass="custom-table"
            [value]="companyData?.trainers" dataKey="code" [paginator]="true" [scrollable]="true" [rows]="10"
            [selectionPageOnly]="true" [tableStyle]="{'min-width': '40rem'}">
            <ng-template pTemplate="header">
                <tr>
                    <th>{{"name"| translator}} </th>
                    <th>{{"Email"| translator}}</th>
                    <th>{{"Gender"| translator}}</th>
                    <th>{{"National ID"| translator}}</th>
                    <th>{{"Phone Number"| translator}}</th>
                    <th *ngIf="!trainerView">{{"Action"| translator}}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-trainer>
                <tr>
                    <td>{{trainer.name.first}} {{trainer.name.middle}} {{trainer.name.last}}</td>
                    <td>{{trainer.email}}</td>
                    <td>{{trainer?.gender}}</td>
                    <td>{{trainer?.national_id}}</td>
                    <td>{{trainer?.phone}}</td>

                    <td *ngIf="!trainerView">
                        <span class="d-flex align-items-center">
                            <span class="tabel-circle-btn">
                                <i pTooltip='{{"Edit Trainer Details"| translator}}' tooltipPosition="top"
                                    (click)="trainerDataHolder = trainer ; updateTrainer = true; "
                                    class="pi pi-file-edit"></i>
                            </span>
                            <span class="tabel-circle-btn">
                                <i pTooltip='{{"Remove trainer"| translator}}' tooltipPosition="top"
                                    (click)="confirmDeleteTrainer(trainer?._id)" class="pi pi-times"></i>
                            </span>
                            <span *ngIf="trainer.active.status" class="tabel-circle-btn">
                                <i  pTooltip='{{"Block Coordinator"| translator}}'
                                    tooltipPosition="top" (click)="deactivateInit(trainer?._id)"
                                    class="pi pi-minus-circle"></i>
                            </span>
                            <span *ngIf="!trainer.active.status" class="tabel-circle-btn">
                                <i pTooltip='{{"UnBlock Coordinator"| translator}}' tooltipPosition="top"
                                    (click)="UndoDeactivateUser(trainer?._id)" class="pi pi-check"></i>
                            </span>
                        </span>
                    </td>

                </tr>
            </ng-template>
        </p-table>

    </div>
</div>

<!-- skelition   -->
<app-skelitions [hidden]="!skelition" [value]="9" class="mb-2"></app-skelitions>
<app-footer></app-footer>


<!-- Add Trainer -->
<p-dialog [blockScroll]="true" [draggable]="false" header='{{"Add Trainer" | translator}}'
    [(visible)]="addTrainnerModal" [style]="{margin: '0rem 1rem' , width:'70vw'}" [maximizable]="true">
    <!-- <app-signup-form (updatedData)="handleUpdatedUserData($event)" *ngIf="editDialog" [type]="'UPDATE'"
        [data]="editData"></app-signup-form> -->
    <app-add-external-user *ngIf="addTrainnerModal" (updatedData)="handleUpdatedUserData($event)" [type]="'CREATE'"
        [ExternalType]="'trainer'" [company]="this.companyID.company"></app-add-external-user>
</p-dialog>


<!-- Add External Coordinator -->
<p-dialog [blockScroll]="true" [draggable]="false" header='{{"Add External Coordinator" | translator}}'
    [(visible)]="addCoordinatorModal" [style]="{margin: '0rem 1rem' , width:'70vw'}" [maximizable]="true">
    <app-add-external-user *ngIf="addCoordinatorModal" (updatedData)="handleUpdatedUserData($event)" [type]="'CREATE'"
        [ExternalType]="'Coordinator'" [company]="this.companyID.company"></app-add-external-user>
</p-dialog>

<!-- Update Trainer -->
<p-dialog [blockScroll]="true" [draggable]="false" header='{{"Edit Trainer" | translator}}' [(visible)]="updateTrainer"
    [style]="{margin: '0rem 1rem' , width:'70vw'}" [maximizable]="true">
    <!-- <app-signup-form (updatedData)="handleUpdatedUserData($event)" *ngIf="editDialog" [type]="'UPDATE'"
        [data]="editData"></app-signup-form> -->
    <app-add-external-user *ngIf="updateTrainer" (updatedData)="handleUpdatedUserData($event)" [type]="'UPDATE'"
        [data]="trainerDataHolder" [ExternalType]="'trainer'"
        [company]="this.companyID.company"></app-add-external-user>
</p-dialog>

<p-confirmDialog [style]="{margin: '0rem 1rem'}"></p-confirmDialog>